"use client";
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsxs as c, jsx as e } from "react/jsx-runtime";
import { useTheme as a } from "../../hooks.js";
import { useIsInverseVariant as v } from "../../theme-variant-context.js";
import { vars as i } from "../../skins/skin-contract.css-mistica.js";
const h = (_param)=>{
    var { color: r, size: o = 24 } = _param, t = _object_without_properties(_param, [
        "color",
        "size"
    ]);
    const s = v(), l = r !== null && r !== void 0 ? r : s ? i.colors.inverse : i.colors.neutralHigh, { skinName: n } = a();
    return n.match(/^o2-new/i) ? /* @__PURE__ */ c("svg", _object_spread_props(_object_spread({
        width: o,
        height: o,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, t), {
        children: [
            /* @__PURE__ */ e("path", {
                fill: l,
                d: "m10.123 7.617 6.834-3.891-2.935-1.672a.3.3 0 0 0-.345 0L7.122 5.802c.035 0 3.001 1.815 3.001 1.815M20.577 5.802l-2.552-1.464-6.9 3.923 2.726 1.716zM14.366 18.856v-7.99l6.726-4.176v7.779a.38.38 0 0 1-.17.32zM6.948 9.617c2.587 0 4.726 2.176 4.726 4.888 0 .856-.379 1.82-.932 2.82l2.587 1.571v-8.03L6.604 6.69v2.963c.052 0 .114-.009.175-.018s.119-.018.169-.018"
            }),
            /* @__PURE__ */ e("path", {
                fill: l,
                d: "M6.948 10.333c-2.209 0-4.038 1.856-4.038 4.176 0 2.212 3.59 7.139 3.763 7.347.07.072.17.144.275.144.1 0 .209-.072.274-.144 0 0 .758-1.104 1.551-2.532q.097-.171.192-.33c.074-.126.147-.25.222-.386l.02-.035c.89-1.519 1.74-2.969 1.74-4.068.039-2.28-1.79-4.172-4-4.172m0 5.244c-.724 0-1.311-.604-1.311-1.356 0-.748.584-1.356 1.31-1.356.728 0 1.312.604 1.312 1.356s-.588 1.356-1.311 1.356"
            })
        ]
    })) : /* @__PURE__ */ c("svg", _object_spread_props(_object_spread({
        width: o,
        height: o,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, t), {
        children: [
            /* @__PURE__ */ e("path", {
                fill: l,
                d: "m10.123 7.617 6.834-3.891-2.935-1.672a.3.3 0 0 0-.345 0L7.122 5.802c.035 0 3.001 1.815 3.001 1.815M20.577 5.802l-2.552-1.464-6.9 3.923 2.726 1.716zM14.366 18.856v-7.99l6.726-4.176v7.779a.38.38 0 0 1-.17.32zM6.948 9.617c2.587 0 4.726 2.176 4.726 4.888 0 .856-.379 1.82-.932 2.82l2.587 1.571v-8.03L6.604 6.69v2.963c.052 0 .114-.009.175-.018s.119-.018.169-.018"
            }),
            /* @__PURE__ */ e("path", {
                fill: l,
                d: "M6.948 10.333c-2.209 0-4.038 1.856-4.038 4.176 0 2.212 3.59 7.139 3.763 7.347.07.072.17.144.275.144.1 0 .209-.072.274-.144 0 0 .758-1.104 1.551-2.532q.097-.171.192-.33c.074-.126.147-.25.222-.386l.02-.035c.89-1.519 1.74-2.969 1.74-4.068.039-2.28-1.79-4.172-4-4.172m0 5.244c-.724 0-1.311-.604-1.311-1.356 0-.748.584-1.356 1.31-1.356.728 0 1.312.604 1.312 1.356s-.588 1.356-1.311 1.356"
            })
        ]
    }));
}, M = h;
export { M as default };
